<div class="sorting-select">
  <form [formGroup]="form">
    <vw-select
      [id]="'sort'"
      [items]="options"
      [parentForm]="form"
      [formControlProp]="'sort'"
      [template]="option"
      [emptyOption]="false"
      [label]="'sort' | translate"
    >
    </vw-select>
  </form>

  <ng-template #option let-item="item">
    <option [value]="item.value" [selected]="item.value === form.value.sort">
      {{ item.displayName }}
    </option>
  </ng-template>
</div>
